<template>
	<div class="dialog-box">
		<div class="title">批量处理数据中</div>
		<el-progress type="circle" :percentage="percentage"></el-progress>
		<div class="tips1">正在处理，请稍等...</div>
		<div class="tips2">过程中请勿操作此页面，防止处理失败</div>
	</div>
</template>

<script>

export default {
	name: 'Progress',

	props: {
		keyWord: {
			type: String
		},
		progressModal: {
			type: Boolean
		}
	},
	data () {
		return {
			timer: null,
			percentage: 0
		}
	},
	created () {
		this.loop()
	},
	beforeDestroy () {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		loop () {
			this.timer = setTimeout(() => {
				this.check()
				this.loop()
			}, 1000)
		},
		clear () {
			let params = {
				operate: this.keyWord
			}
			let url
			if (this.keyWord.indexOf('createOrderBatch') !== -1) {
				url = `${this.$fxBaseApi.urlQIVShop}/order/clearOperateProgress`
			} else {
				url = `${this.$fxBaseApi.urlQIVShop}/customer/clearOperateProgress`
			}
			this.$store.dispatch('requestPost', {
				url: url,
				data: params
			}).then(res => {
			})
		},
		check () {
			let params = {
				operate: this.keyWord
			}
			let url
			if (this.keyWord.indexOf('createOrderBatch') !== -1) {
				url = `${this.$fxBaseApi.urlQIVShop}/replaceorder/batchOperateProgress`
			} else {
				url = `${this.$fxBaseApi.urlQIVShop}/customer/batchOperateProgress`
			}
			this.$store.dispatch('requestPost', {
				url: url,
				data: params
			}).then(res => {
				this.percentage = res.data.prograss
				if (this.percentage === 100) {
					let resultMsg = JSON.parse(res.msg)
					this.clear()
					this.$emit('reload')
					this.$emit('update:progressModal', false)
					if (res.result === true) {
						// this.$message.success(res.msg)
						this.$emit('resultMsg', resultMsg)
						this.$emit('inportCustomDialogModel', true)
						this.$parent.tableReload()
					} else {
						// this.$message.error(res.msg)
						this.$emit('resultMsg', resultMsg)
						this.$emit('inportCustomDialogModel', true)
						this.$parent.tableReload()
					}
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
	.dialog-box {
		display: flex
		flex-flow: column
		align-items: center
		justify-content: center
		.title, .tips1 {
			font-size: 15px;
			font-weight: bold;
			color: #333333;
			padding: 18px 0
		}
		.tips2 {
			font-size: 12px;
			font-weight: 400;
			color: #808080;
		}
	}
</style>
<style lang="stylus">

</style>
